/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

export class CurrentMenuItemPropertyModel {

    constructor(urlHashPart, isFromBrowserAction, isOpenInNewWindow, isInLineUXApp) {
        this._urlHashPart = urlHashPart;
        this._isFromBrowserAction = isFromBrowserAction;
        if (!isFromBrowserAction) {
            this._isFromBrowserAction = false;
        }
        this._isOpenInNewWindow = isOpenInNewWindow;
        if (!isOpenInNewWindow) {
            this._isOpenInNewWindow = false;
        }
        this._isInLineUXApp = isInLineUXApp;
        if (!isInLineUXApp) {
            this._isInLineUXApp = false;
        }
    }

    getUrlHashPart() {
        return this._urlHashPart;
    }

    isFromBrowserAction() {
        return this._isFromBrowserAction;
    }

    isOpenInNewWindow() {
       return this._isOpenInNewWindow;
    }

    isInLineUXApp() {
       return this._isInLineUXApp;
    }
}